import { render, staticRenderFns } from "./__detail_item_list_storehouse.vue?vue&type=template&id=23a25722&scoped=true&"
import script from "./__detail_item_list_storehouse.vue?vue&type=script&lang=js&"
export * from "./__detail_item_list_storehouse.vue?vue&type=script&lang=js&"
import style0 from "./__detail_item_list_storehouse.vue?vue&type=style&index=0&id=23a25722&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23a25722",
  null
  
)

export default component.exports